import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/**
 * Auth Interceptor que usa cookies en lugar de headers Authorization
 * Las cookies se envían automáticamente por el navegador cuando withCredentials: true
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip if the request is not going to our API
  if (!req.url.startsWith(environment.apiUrl) && !req.url.startsWith(environment.apiPublicUrl)) {
    return next(req);
  }

  // Para peticiones a nuestra API, asegurar que se envíen las cookies
  const authReq = req.clone({
    // IMPORTANTE: Esto hace que se envíen las cookies automáticamente
    withCredentials: true
  });
  
  console.log('Auth interceptor: Sending request with cookies to:', req.url);
  
  return next(authReq);
};
